import { useEffect, useState } from "react";

enum BusinessTypeProperties {
  BUSINESS = "비즈니즈",
  EXPOSED_STANDARD = "노출 기준",
  WATCHED_STANDARD = "시청 기준",
  ATTENTIONED_STANDARD = "주목 기준",
}

const useBusinessTypeList = (initialPage: number) => {
  const transformData = (
    rawData: any[]
  ): Record<BusinessTypeProperties, any>[] => {
    return rawData.map((item) => ({
      [BusinessTypeProperties.BUSINESS]: item.business,
      [BusinessTypeProperties.EXPOSED_STANDARD]: item.exposedStandard,
      [BusinessTypeProperties.WATCHED_STANDARD]: item.watchedStandard,
      [BusinessTypeProperties.ATTENTIONED_STANDARD]: item.attentionedStandard,
    }));
  };
  const [isFetchingComplete, setIsFetchingComplete] = useState(false);

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [data, setData] = useState<any[]>([]);
  const [count, setCount] = useState<number>();
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState<string[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);

  const handleDeleteClick = (businessTypeId: string) => {
    const result = window.confirm("삭제하시겠습니까?");
    if (result) {
      fetch(`${process.env.REACT_APP_URL}/business-type/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ businessTypeId: businessTypeId }),
      })
        .then(async (response) => {
          if ((await response.json()) === 1451) {
            // 키 참조 에러처리
            alert("매체 테이블과 참조되어 있어 삭제가 불가능합니다.");
            window.location.reload();
          } else {
            window.location.reload();
          }
        })
        .catch((error) => {
          // alert("삭제에 실패하였습니다.");
          window.location.reload();
        });
    }
  };

  const fetchData = async (page: any) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/business-type/list?page=${page}`
      );

      const jsonData = await response.json();
      const transformedData = transformData(jsonData.data.list || []);
      //원본 전체 데이터 보여지는데이터는 tableData로 관리
      setData((prevData) => [...prevData, ...transformedData]);

      if (columns.length === 0 && transformedData.length > 0) {
        const newColumns = Object.keys(transformedData[0]);
        setColumns(newColumns);
      }

      const countResponse = await fetch(
        `${process.env.REACT_APP_URL}/business-type/list`
      );

      if (!countResponse.ok) {
        throw new Error("Network request failed");
      }

      const countJsonData = await countResponse.json();
      const totalDataCount = countJsonData.data.count;
      if (
        transformedData.length === 0 ||
        totalDataCount <= data.length + transformedData.length
      ) {
        setIsFetchingComplete(true);
      }

      setCount(countJsonData.data.count);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return {
    data,
    loading,
    currentPage,
    nextPage,
    count,
    columns,
    tableData,
    setTableData,
    handleDeleteClick,
    isFetchingComplete,
  };
};

export default useBusinessTypeList;
